module.exports = __webpack_public_path__ + "img/c04_unitstartechcodification_Normal_ua.a2ade8da.webp";